import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
// import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  // {
  //   link: 'https://facebook.com/md',
  //   label: 'Facebook',
  //   icon: faFacebookF,
  // },
  {
    link: 'https://www.linkedin.com/in/sam-lacomy-b503b11b8/',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://www.instagram.com/samlacomydev/',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'https://github.com/Slacomy',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://twitter.com/SamLacomyDev',
    label: 'Twitter',
    icon: faTwitter,
  },
  {
    link: 'mailto:slacomy@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
